import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LocalizationProvider from './context/Localization';
import UserSettingsProvider from './context/UserSettings';
var queryClient = new QueryClient();
var MAX_RETRIES = 2;
var Providers = function (_a) {
    var children = _a.children, userSettings = _a.userSettings;
    queryClient.setDefaultOptions({
        queries: {
            retry: MAX_RETRIES,
        },
    });
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(UserSettingsProvider, { userSettings: userSettings, children: _jsx(LocalizationProvider, { children: children }) }) }));
};
export default Providers;
